/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {SchemaMetadata, SecurityContext} from '@angular/core';
/**
 * @abstract
 */
export abstract class ElementSchemaRegistry {
/**
 * @abstract
 * @param {?} tagName
 * @param {?} propName
 * @param {?} schemaMetas
 * @return {?}
 */
hasProperty(tagName: string, propName: string, schemaMetas: SchemaMetadata[]) {}
/**
 * @abstract
 * @param {?} tagName
 * @param {?} schemaMetas
 * @return {?}
 */
hasElement(tagName: string, schemaMetas: SchemaMetadata[]) {}
/**
 * @abstract
 * @param {?} elementName
 * @param {?} propName
 * @param {?} isAttribute
 * @return {?}
 */
securityContext(elementName: string, propName: string, isAttribute: boolean) {}
/**
 * @abstract
 * @return {?}
 */
allKnownElementNames() {}
/**
 * @abstract
 * @param {?} propName
 * @return {?}
 */
getMappedPropName(propName: string) {}
/**
 * @abstract
 * @return {?}
 */
getDefaultComponentElementName() {}
/**
 * @abstract
 * @param {?} name
 * @return {?}
 */
validateProperty(name: string) {}
/**
 * @abstract
 * @param {?} name
 * @return {?}
 */
validateAttribute(name: string) {}
/**
 * @abstract
 * @param {?} propName
 * @return {?}
 */
normalizeAnimationStyleProperty(propName: string) {}
/**
 * @abstract
 * @param {?} camelCaseProp
 * @param {?} userProvidedProp
 * @param {?} val
 * @return {?}
 */
normalizeAnimationStyleValue(
      camelCaseProp: string, userProvidedProp: string,
      val: string|number) {}
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
